import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35f4b7b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "layout-header" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "d-flex align-items-center gap-5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-logo" }, "制作メニュー")
], -1))
const _hoisted_6 = { class: "list-menu" }
const _hoisted_7 = { class: "d-flex mb-0 list-unstyled" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "HOME", -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原稿を書く ", -1))

import BaseButton from '@/components/shared/BaseButton.vue';
import helper from '@/utils/helper';
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const showButton = computed(() => !['invite.confirm'].includes(String(route.name)));

const goToWordPress = () => {
  window.open(process.env.VUE_APP_ENDPOINT_WP, '_blank', 'noopener,noreferrer');
};

const goToHelp = () => {
  window.location.href = process.env.VUE_APP_HELP_URL;
};

const GoBack = () => {
  router.back();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: { name: 'home' } }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require('@/assets/images/logo.svg'),
                alt: "writers BASE",
                height: "50"
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          })
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_unref(helper).checkRoles('home') && showButton.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  class: "d-flex align-items-center gap-1",
                  to: { name: 'home' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(helper).checkRoles('home') && showButton.value)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 1,
                title: "前に戻る",
                class: "logout-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (GoBack()))
              }))
            : _createCommentVNode("", true),
          (_unref(helper).checkRoles('article.create') && showButton.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  class: "d-flex align-items-center gap-1",
                  to: "/article#create"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(helper).checkRoles('home') && showButton.value)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 3,
                title: "記事を読む",
                class: "logout-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goToWordPress()))
              }))
            : _createCommentVNode("", true),
          (_unref(helper).checkRoles('home') && showButton.value)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 4,
                title: "ヘルプ",
                class: "logout-btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (goToHelp()))
              }))
            : _createCommentVNode("", true),
          (_unref(helper).checkRoles('home') && showButton.value)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 5,
                title: "ログアウト",
                class: "logout-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(helper).logoutWp()))
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})